import React, { useState } from "react";
import Tab from "../generic/Tab";
import AddMaterialForm from "./AddMaterialForm";
import BulkAddInventoryForm from "./BulkAddInventoryForm";
import { UPDATE_TABS } from "../../constants/TabTypes";

const TABS = UPDATE_TABS;

const AddInventory: React.FC = () => {
    const [ activeTab, setActiveTab ] = useState<string>(TABS[0]);
    return (
        <div className={"py-8"}>
            {/* Tabs */}
            <Tab tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} mainTabStyle={"alt"}/>

            {/* Tab Content */}
            <div>
                {activeTab === TABS[0] && <AddMaterialForm/>}
                {activeTab === TABS[1] && <BulkAddInventoryForm/>}
            </div>
        </div>
    );
};

export default AddInventory;
